import type { MatchTypeTrackingValue } from '../constants/MatchTypeTrackingMap';
import { MatchTypeTrackingMap } from '../constants/MatchTypeTrackingMap';
import type { AssetResultMatch } from '../types';

type MatchWithTypename = { __typename?: AssetResultMatch['__typename'] };

// Fallback function to derive a tracking value from the match typename if it's
// not found in the map (if a new value is introduced before the map is updated)
const getMatchTypeTrackingValueFallback = (
  matchTypename: AssetResultMatch['__typename']
) => matchTypename?.replace('Match', '');

// from a single matchTypename
export const getMatchTypeTrackingValue = (
  matchTypename?: AssetResultMatch['__typename'] | null
) => {
  const trackingValue = matchTypename
    ? MatchTypeTrackingMap[matchTypename] ||
      getMatchTypeTrackingValueFallback(matchTypename)
    : undefined;
  return trackingValue ? [trackingValue] : [];
};

// from an array of match nodes
export const getMatchTypeTrackingValues = (
  matches: Array<MatchWithTypename | null | undefined>
): MatchTypeTrackingValue[] =>
  matches.reduce<MatchTypeTrackingValue[]>((values, match) => {
    const trackingValue = getMatchTypeTrackingValue(match?.__typename);
    if (trackingValue.length) values.push(...trackingValue);
    return values;
  }, []);
